import React from 'react';
import classNames from 'classnames';
import { ButtonSize, Button, ButtonPriority, HoverStyles } from 'wix-ui-tpa/cssVars';
import { classes } from './previous-button.st.css';
import { ForcedState, useForcedState } from '../../../../../contexts/forced-state-context';
const PreviousButton = _ref => {
  let {
    previousText,
    className,
    onClick
  } = _ref;
  const forcedState = useForcedState();
  const hover = forcedState.includes(ForcedState.PREVIOUS_BUTTON_HOVER);
  return /*#__PURE__*/React.createElement(Button, {
    className: classNames(classes.previousButton, {
      [classes.previousButtonHover]: hover
    }, className),
    hoverStyle: HoverStyles.underline,
    upgrade: true,
    wrapContent: true,
    priority: ButtonPriority.basicSecondary,
    size: ButtonSize.large,
    onClick: onClick
  }, previousText);
};
export default PreviousButton;
//# sourceMappingURL=previous-button.js.map